import React, { memo, useCallback, useMemo, useRef, useState } from 'react';

import { Button } from '@material-ui/core';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import { Modal, Table } from '~/components';
import { t } from '~/helpers';

import FormSubitem from '../FormSubitem';
import * as S from './styles';

function criaIdLocal() {
  return Math.random().toString();
}

function Subitens({ data, onCallback, statusOptions }) {
  const [active, setActive] = useState([]);
  const modalRef = useRef(null);

  const cells = useMemo(
    () => [
      {
        id: 'descricaoobservacaoatendimentoitem',
        label: t('s.cadastro.pitstop.descricaoobservacao'),
      },
      {
        id: 'statusobservacaoatendimentoitem',
        label: t('s.cadastro.pitstop.statusobservacao'),
        format: (value) =>
          statusOptions.find((status) => status.value === value)?.label || '',
      },
    ],
    [statusOptions]
  );

  const handleChangeModifyActive = useCallback((value) => {
    setActive(value);
  }, []);

  const handleOpenModalToUpdateRow = useCallback(() => {
    if (isEmpty(active)) {
      return;
    }

    modalRef.current.handleOpenModal({
      data: active[0],
      statusOptions,
    });
  }, [active, statusOptions]);

  const handleRemoveActive = useCallback(() => {
    onCallback(data.filter((item) => item.idlocal !== active[0].idlocal));
    setActive([]);
  }, [active, data, onCallback]);

  const handleUpdateOrCreateInRow = useCallback(
    (value) => {
      const item = {
        ...value,
        idlocal: value.idlocal || criaIdLocal(),
      };

      const values = [...data];
      const index = values.findIndex((row) => row.idlocal === item.idlocal);

      if (index >= 0) {
        values[index] = item;
      } else {
        values.push(item);
      }

      onCallback(values);
      setActive([]);
    },
    [data, onCallback]
  );

  return (
    <S.Wrapper>
      <header>
        <h3>{t('s.configuracao.arqueacao.itens')}</h3>

        <div>
          <Button
            variant="contained"
            color="primary"
            size="small"
            type="button"
            onClick={() => modalRef.current.handleOpenModal({ statusOptions })}
          >
            {t('s.geral.botaoincluir')}
          </Button>

          <Button
            variant="contained"
            color="primary"
            size="small"
            type="button"
            disabled={isEmpty(active)}
            onClick={handleOpenModalToUpdateRow}
          >
            {t('s.geral.botaoalterar')}
          </Button>

          <Button
            variant="contained"
            color="secondary"
            size="small"
            type="button"
            disabled={isEmpty(active)}
            onClick={handleRemoveActive}
          >
            {t('s.geral.botaoexcluir')}
          </Button>
        </div>
      </header>

      <Table
        noButton
        showPagination={false}
        paginate={99}
        cells={cells}
        data={data}
        onCallback={handleChangeModifyActive}
        unique="idlocal"
        size="small"
      />

      <Modal
        form
        disableBackdropClick
        disableEscapeKeyDown
        title={t('s.configuracao.arqueacao.itens')}
        maxWidth="xs"
        ref={modalRef}
        onForm={handleUpdateOrCreateInRow}
        component={FormSubitem}
      />
    </S.Wrapper>
  );
}

Subitens.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  onCallback: PropTypes.func.isRequired,
  statusOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default memo(Subitens);
